import * as Sentry from '@sentry/react';

export const logError = (error: Error | unknown, additionalData?: unknown) => {
	console.error(error, additionalData);

	Sentry.captureException(error, {
		extra: {
			additionalData,
			session: window.localStorage.getItem('token'),
		} as any,
	});
};
